<template>  
<div ref="container" style="width:100%;display:flex;flex:1 1 auto;flex-direction:column">
    <template v-if="loadingData">      
      <v-progress-circular v-if="loading" :width="15" :size="350" :value="loadingValue" color="primary"  style="align-self:center;margin-bottom:auto;margin-top:auto">
        <span class="headline">{{$t('Pilot.Graphics.LoadingData')}}</span>
      </v-progress-circular>                
      <div v-else>                
        <span status="error" :exception="$t('Pilot.Graphics.FailDownloadData')" id="full_page_loaded"></span>
        <v-alert  :value="true" type="info"  >{{$t('Pilot.Graphics.FailDownloadData')}}</v-alert>
        <v-btn color="primary" @click="tryEnsureData()">{{$t('Pilot.Graphics.TryReload')}}</v-btn>
      </div>
    </template>
    <template v-else-if="mission.dataNavigation.length > 0 || mission.dataScience.length > 0">    
      <span :status="nbCached == totalCache?'success':'error'" id="full_page_loaded" v-if="allCacheDone" :exception="exception" ></span>
      {{totalDone}} / {{totalCache}}
      <div style="flex:1 0 auto;position:relative;" class="mr-4">
   <Responsive :breakpoints="{
    small: el => el.width <= 420
  }">    
  <v-layout slot-scope="el" @mousedown.prevent.stop="stopClick" class="scrollable-container"  ref="detail" mt-2 px-4 row wrap>  
    <template v-for="dataLimitMode in $options.dataLimitModes">      
      <template v-if="mission.dataScience.length > 0">
      <template v-for="(graphGroup,index) in sciGraphs"> 
      <v-flex class="xs12 text-xs-center body-2 mt-1" :key="`${graphGroup.name}_${dataLimitMode}`">{{tryTranslate(graphGroup.name)}}</v-flex>
      <v-flex style="position:relative;" class="px-2" :class="{sm12:el.is.small,sm8:!el.is.small && graph.size==4,sm4:!el.is.small && graph.size==2}" v-for="graph in graphGroup.graphs" :key="`${graph.id}_${dataLimitMode}`">                  
          <div class="graph mb-2" >
            <mission-scatter-plot      
                :sciGraph="true" 
                :mainVariable="graphGroup.name"
                :pointSize="1" 
                :abscisseVariable="graph.abscisse"
                :ordonneeVariable="graph.ordonnee"
                :colorVariable="graph.color"
                :uiid="uiid" 
                :prefixe="`${graph.id}_${dataLimitMode}`"
                :allowClick="true"
                :allowZoom="false"                        
                :marginWidth="5"   
                :offsetLegendX="5"
                :offsetLegendY="5"  
                :colorGradientWidth="5"            
                :offsetLegendColor="5"
                :xTicks="graph.xTicks"
                :yTicks="5"
                :colorTicks="5"      
                :useCacheImg="true"
                :forceGenereCache="true"
                :redraw="componentRefresh"              
                :dataLimit="dataLimitMode"
                :autoScaleX="graph.autoScaleX"   
                @cached="onCacheOk()"     
                @cacheFailed="onCacheFail(graphGroup.name)"      
                />        
          </div>
        </v-flex>  
        <v-flex v-if="index != sciGraphs.length-1"  class="xs12" :key="`hr_${graphGroup.name}_${dataLimitMode}`"> <hr  />        </v-flex>        
      </template> 
      </template>
      <template v-if="mission.dataNavigation.length > 0">
      <v-flex v-for="graph in navGraphs" style="position:relative;" class="px-2" :class="{sm12:el.is.small,sm6:!el.is.small}" :key="`${graph.id}_${dataLimitMode}`">                    
            <v-flex class="xs12 text-xs-center body-2 mt-1" :key="graph.name">{{tryTranslate(graph.name)}}</v-flex>                
            <div class="graph mb-2" >
              <mission-scatter-plot  
                  :sciGraph="false"             
                  :pointSize="1" 
                  :abscisseVariable="graph.abscisse"
                  :ordonneeVariable="graph.ordonnee"
                  :colorVariable="graph.color"
                  :uiid="uiid" 
                  :prefixe="`${graph.id}_${dataLimitMode}`"
                  :allowClick="true"
                  :allowZoom="false"                        
                  :marginWidth="5"   
                  :offsetLegendX="5"
                  :offsetLegendY="5"  
                  :colorGradientWidth="5"            
                  :offsetLegendColor="5"
                  :xTicks="graph.xTicks"
                  :yTicks="5"
                  :colorTicks="5"      
                  :useCacheImg="true"
                  :forceGenereCache="true"
                  :redraw="componentRefresh"              
                  :dataLimit="dataLimitMode"
                  :mission="mission"
                  :tabState="currentDetailMission"
                  @cached="onCacheOk()"
                  />        
            </div>
          </v-flex>
      </template>
    </template>
  </v-layout>     
    </Responsive> 
    </div>
    </template>
    <template v-else>
      <span status="error" :exception="$t('Pilot.Graphics.NoDataAvailable')" id="full_page_loaded"></span>
      <span class="display-2" style="margin:auto">{{$t('Pilot.Graphics.NoDataAvailable')}}</span>
    </template>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'  
  import {zoomIdentity} from 'd3'  
  import MissionScatterPlot from '@/components/charts/MissionScatterPlot'
  import { dataLimitMode } from '@/models/ui/GraphUiState'
  

  export default {
    components:{MissionScatterPlot},
    props:  {
      isleft:Boolean,
      uiid:{
          type: String,
          required: true
      }
   },      
   name: 'CacheAllGraphicsList',   
   data(){
     return {
        interval: {},
        loadingValue: 0,
        loading: true,
        nbCached: 0,
        nbFailed:0,
        failedNames:[],
        type:""
      }
   },
   mounted() {     
     if(this.loadingData){
      this.interval = setInterval(() => {
        this.loadingValue = (this.loadingValue + 10) % 110        
      }, 1000)
     }
   },
   computed: {
       ...mapGetters([            
         'currentDetailMission',
         'allGraphUiStateByUiid',
         'missions'
      ]),     
      mission(){
        return this.currentDetailMission.mission
      },
      loadingData(){                
        return ((this.type == "" || this.type == "Pld1" || this.type == "Pld2" || this.type == "Ad2cp") && !this.mission._dataScienceLoaded) 
        || ((this.type == "" || this.type == "Gli") &&  !this.mission._dataNavigationLoaded)        
      },      
      allGraphUiState() {                
        return this.allGraphUiStateByUiid(this.uiid)
      },           
      dataLimit(){
        return this.allGraphUiState.dataLimit
      },
      componentRefresh() {
        return this.allGraphUiState && this.allGraphUiState.refresh
      },
      allCacheDone(){
        return  this.totalDone > 0 && this.totalDone == this.totalCache
      },   
      totalDone(){
        return this.nbCached + this.nbFailed
      },
      totalCache(){
        return  (
                  this.$options.dataLimitModes.length  * 
                  (
                    (((this.type == "" || this.type == "Pld1" || this.type == "Pld2" || this.type == "Ad2cp")?1:0) * this.sciGraphs.length * 2) +  
                    (((this.type == "" || this.type == "Gli")?1:0) * this.navGraphs.length)
                  )
                ) || 0
      },
      exception() {
        return this.failedNames.length > 0?`${this.nbFailed} graph(s) non mis en cache : ${this.failedNames.join(', ')}`:''
      },
      navGraphs() {
        return this.mission.navPlotVariables.filter(v => v.autoPlot).map(currentValue => { return {
          id: currentValue.variable,
          name : currentValue.name,
          abscisse : this.mission.xNavScatterVariable,
          ordonnee : currentValue.variable,
          color : "None",
          transform : zoomIdentity,
          size : 2,
          xTicks: 3,
          dataLimit: dataLimitMode.ALL
        }})
      },      
      sciGraphs() {
        return this.mission.sciPlotVariables.filter(g => g.autoPlot
          && (g.name.toLowerCase().indexOf('ad2cp_v') == -1 || g.name.toLowerCase().indexOf('_cn2') > 0)
        ).map(sciPlotVariable => {
            return { 
              name: sciPlotVariable.name,                     
              graphs: [{
                id: `COLOR_${sciPlotVariable.variable}`,
                name : "Color " + sciPlotVariable.name,
                abscisse : this.mission.xSciScatterVariable,
                ordonnee : this.mission.ySciScatterVariable,
                color : sciPlotVariable.variable,
                transform : zoomIdentity,
                size : 4,
                xTicks: 3,
                dataLimit: this.dataLimit,
                autoScaleX:false
              },{
                id: `PROFILE_${sciPlotVariable.variable}`,              
                name : "Profile " + sciPlotVariable.name,
                abscisse : sciPlotVariable.variable,
                ordonnee : this.mission.ySciProfileVariable,
                color : "None",
                transform : zoomIdentity,
                size : 2,
                xTicks: 5,
                dataLimit: this.dataLimit,
                autoScaleX: true
              }]
            }
        }) 
      }
    },    
    created() {
      const urlParams = new URLSearchParams(window.location.search);
      this.type = urlParams.get("type") || ""                 
      this.tryEnsureData()      
      this.$options.dataLimitModes = [dataLimitMode.LAST_12H,dataLimitMode.LAST_24H,dataLimitMode.ALL]
    },
    watch : {      
      mission(newValue) {       
        this.nbCached = 0
        this.nbFailed = 0
        this.failedNames.splice(0,this.failedNames.length)
        this.tryEnsureData()
      },
      loadingData(newValue) {
        if(!newValue) {
          clearInterval(this.interval)
        }
      }
    },    
    beforeDestroy () {
      clearInterval(this.interval)
    },
    methods: {    
       tryEnsureData(){
          if(this.mission.misId != null) {
            this.loading = true
            const dataToLoad = []
            if(this.type == "" || this.type == "Pld1" || this.type == "Pld2" || this.type == "Ad2cp") dataToLoad.push(this.$store.myActions.MISSION_ENSURE_DATA_SCIENCE(this.mission.misId))
            if(this.type == "" || this.type == "Gli") dataToLoad.push(this.$store.myActions.MISSION_ENSURE_DATA_NAVIGATION(this.mission.misId))
            Promise.all(dataToLoad).finally(()=> {              
              this.loading = false              
            }); 
          }
      },         
      tryTranslate(key) {        
        const transKey = `Pilot.Graphics.${key}`
        const trad = this.$t(transKey)
        return transKey == trad?key:trad
      },
      selectGraph(graph){                   
        this.$store.myActions.MISSION_NAVTO_DETAIL({cmp:'MissionDetailScienceGraphics',isleft:!this.isleft,'label':graph.name}).then(() => {
          const tabsMission = !this.isleft? this.currentDetailMission.tabsleft: this.currentDetailMission.tabsright
          //on attend que le composant soit créé
          this.$nextTick(()=> this.$store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsMission.selected}))
        })        
      },
      stopClick(){

      },
      onCacheOk(){
        this.nbCached++
      },
      onCacheFail(name){
        this.nbFailed++
        this.failedNames.push(name)
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .graph{
    border:1px solid #ddd;
    box-sizing: content-box;
    width:100%;
    height:175px;
    position:relative;
    cursor: pointer;
  }
</style>
